// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Agent-only presentation. Portal roots receive agent-theme explicitly. */
.agent-page,
.agent-theme {
  --agent-blue: #165bfb;
  --agent-ink: #202c42;
  --agent-muted: #7a8496;
  --agent-line: #e8ecf2;
  --agent-canvas: #f8f9fc;
  --agent-chat: #fcfdff;
  color: var(--agent-ink);
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

.agent-page,
.agent-page .agent-layout {
  height: 100vh;
  height: 100dvh;
  background: var(--agent-canvas);
}

:is(.agent-page, .agent-theme) :is(button, input, textarea, select) {
  font-family: inherit;
}

:is(.agent-page, .agent-theme) :is(button, a, summary) {
  -webkit-tap-highlight-color: transparent;
}

:is(.agent-page, .agent-theme) :focus-visible {
  outline: 3px solid #8eb3ff;
  outline-offset: 3px;
}

:is(.agent-page, .agent-theme) button:disabled {
  cursor: not-allowed;
}

.agent-page .agent-header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--agent-line);
}

.agent-page .agent-header > div {
  border-bottom: 0;
}

.agent-page .agent-header nav a {
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.agent-page .agent-header-sessions,
.agent-page .agent-session-controls {
  min-width: 0;
  max-width: 100%;
}

.agent-page .agent-session-controls {
  gap: 8px;
}

.agent-page .agent-session-controls > button {
  min-height: 40px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 600;
}

.agent-page .agent-session-controls > button:first-child {
  min-width: 0;
  border-color: var(--agent-line);
  color: #495870;
  background: #fff;
  box-shadow: 0 1px 2px #304a7604;
}

.agent-page .agent-session-controls > button:first-child:hover {
  border-color: #c4d6f6;
  background: #f8faff;
}

.agent-page .agent-session-controls > button + button {
  flex-shrink: 0;
  background: var(--agent-blue);
  box-shadow: 0 3px 5px #165bfb12;
}

.agent-page .agent-session-controls > button + button:hover:not(:disabled) {
  background: #084ee9;
}

.agent-page .agent-header button[aria-label='Logout'] {
  min-height: 40px;
  padding: 8px 15px;
  border: 1px solid #f0dce0;
  border-radius: 9px;
  background: #fff5f6;
  color: #b4232f;
  font-size: 12px;
  font-weight: 500;
}

.agent-page .agent-header button[aria-label='Logout']:hover {
  background: #ffebee;
}

.agent-page :is(.agent-content, .agent-conversation, .agent-chat) {
  min-width: 0;
  min-height: 0;
}

.agent-page .agent-conversation {
  background: var(--agent-chat);
}

.agent-page .agent-sidebar-column {
  flex: 0 0 380px;
}

.agent-page .agent-messages {
  overscroll-behavior: contain;
  padding-top: 28px;
}

.agent-page .agent-message {
  margin-bottom: 26px;
}

.agent-page :is(.agent-message-row, .agent-message-body) {
  min-width: 0;
}

.agent-page :is(.message-user-bubble, .message-ai-bubble, .message-error-bubble, .message-warning-bubble) {
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid var(--agent-line);
  box-shadow: none;
}

.agent-page .message-user-bubble {
  border-color: #e4ecfc;
  border-radius: 12px 12px 3px 12px;
  background: #edf3ff;
  color: #496088;
}

.agent-page .message-ai-bubble {
  border-radius: 3px 12px 12px 12px;
  background: #fff;
  color: #58667d;
}

.agent-page :is(.chat-rich-text, .chat-rich-text p) {
  color: inherit;
  font-size: 14px;
  line-height: 1.85;
  overflow-wrap: anywhere;
}

.agent-page .chat-rich-text a {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.agent-page :is(.message-error-bubble, .message-warning-bubble) {
  border-radius: 3px 12px 12px 12px;
}

.agent-page .message-error-bubble {
  border-color: #f3d0d3;
  background: #fff5f6;
}

.agent-page .message-warning-bubble {
  border-color: #f1dfb5;
  background: #fffbf0;
}

.agent-page :is(.message-error-bubble, .message-warning-bubble) p {
  font-size: 14px;
  line-height: 1.8;
}

.agent-page .agent-avatar {
  flex-shrink: 0;
  width: 34px;
  height: 35px;
  border: 1px solid #e0e9ff;
  border-radius: 11px;
  background: linear-gradient(135deg, #f0f5ff, #f7f5ff);
}

.agent-page .agent-avatar > div {
  border-radius: inherit;
  background: transparent;
}

.agent-page .agent-user-avatar {
  flex-shrink: 0;
  width: 34px;
  height: 35px;
  border: 1px solid #e2e8f2;
  border-radius: 11px;
  background: #edf1f7;
}

.agent-page .agent-user-avatar p {
  color: #64738a;
  font-size: 12px;
  font-weight: 600;
}

.agent-page :is(.agent-user-text, .agent-user-text p) {
  color: #496088;
  font-size: 14px;
  line-height: 1.85;
  text-align: left;
  overflow-wrap: anywhere;
}

.agent-page .agent-message-actions {
  gap: 6px;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #e8edf5;
}

.agent-page .agent-message-action {
  min-height: 28px;
  border-radius: 7px;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
}

.agent-page .agent-message-meta {
  border-radius: 6px;
  padding: 4px 7px;
  color: var(--agent-muted);
  background: #f5f7fb;
  font-size: 10px;
}

.agent-page :is(.agent-context-card, .agent-router) {
  border-radius: 10px;
  border-width: 1px;
  padding: 12px;
}

.agent-page .agent-context-card {
  border-color: #e2eafb;
  background: #f7faff;
}

.agent-page .agent-composer-position button:not(.agent-attach-button) {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
}

.agent-page .agent-mention-menu {
  max-width: calc(100vw - 48px);
  border-color: var(--agent-line);
  border-radius: 11px;
  box-shadow: 0 8px 28px #304a7614;
}

.agent-page :is(.agent-context-card, .agent-router) button {
  border-radius: 7px;
  font-weight: 500;
}

.agent-page .agent-composer-fade {
  background: linear-gradient(to top, var(--agent-chat) 45%, #fcfdff00);
}

.agent-page .agent-composer-position {
  width: calc(100% - 48px);
}

.agent-page .agent-composer-position::before {
  position: absolute;
  z-index: -1;
  inset: -20px -16px -52px;
  background: linear-gradient(to top, var(--agent-chat) calc(100% - 20px), #fcfdff00);
  content: '';
  pointer-events: none;
}

.agent-page .agent-composer {
  min-width: 0;
  border: 1px solid #dce4f3;
  border-radius: 12px;
  box-shadow: 0 4px 14px #384c7404;
  transition: border-color 0.15s;
}

.agent-page .agent-composer:focus-within {
  border-color: #98b8fa;
  outline: 3px solid #165bfb08;
}

.agent-page .agent-upgrade-button {
  border-radius: 8px;
  background: var(--agent-blue);
}

.agent-page .agent-upgrade-button:disabled {
  opacity: 0.6;
}

.agent-page .agent-composer-outline {
  display: none;
}

.agent-page :is(.agent-composer-input, .agent-composer-placeholder, .agent-composer-placeholder p) {
  font-size: 14px;
  line-height: 24px;
}

.agent-page .agent-composer-input {
  color: var(--agent-ink);
  outline: none;
}

.agent-page .agent-composer-placeholder {
  color: #909db0;
  pointer-events: none;
}

.agent-page .agent-attach-button {
  border: 1px solid #e2eafb;
  border-radius: 9px;
  color: var(--agent-blue);
  background: #edf3ff;
}

.agent-page .agent-attach-button:hover:not(:disabled) {
  background: #e0eaff;
}

.agent-page .agent-attach-button path {
  fill: currentColor;
}

.agent-page .agent-send-button {
  flex-shrink: 0;
  border: 1px solid var(--agent-line);
  border-radius: 12px;
  background: #f1f4f9;
  transition: background 0.15s, border-color 0.15s;
}

.agent-page .agent-send-button.agent-send-ready:not([aria-disabled='true']) {
  border-color: var(--agent-blue);
  background: var(--agent-blue);
  box-shadow: 0 3px 5px #165bfb12;
}

.agent-page .agent-send-ready:not([aria-disabled='true']) path {
  fill: #fff;
}

.agent-page .agent-send-ready:not([aria-disabled='true']):hover {
  background: #084ee9;
}

.agent-page .suggestion-button {
  max-width: 100%;
  border: 1px solid #dce6f6;
  border-radius: 9px;
  background: #fff;
  color: #536c96;
  box-shadow: 0 1px 2px #304a7604;
  font-size: 12px;
  font-weight: 500;
}

.agent-page .suggestion-button:hover {
  border-color: #adc7ff;
  background: #f7faff;
}

.agent-page .suggestion-button p {
  white-space: normal;
  font-size: 12px;
  line-height: 1.6;
}

.agent-page .agent-suggestion-outline {
  display: none;
}

.agent-page :is(.completion-button-primary, .completion-button-secondary) {
  border-radius: 9px;
  box-shadow: none;
  font-size: 12px;
}

.agent-page .agent-details {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-left: 1px solid var(--agent-line);
  border-radius: 0;
  background: #fff;
}

.agent-page .agent-details-divider {
  display: none;
}

.agent-page .agent-details-scroll {
  flex: 1;
  min-height: 0;
  height: auto;
  padding: 25px 22px 32px;
  overscroll-behavior: contain;
}

.agent-page .agent-details-heading {
  margin-bottom: 24px;
}

.agent-page .agent-details-heading svg {
  width: 22px;
  height: 22px;
}

.agent-page .agent-details-heading > div > div:first-child {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 35px;
  height: 36px;
  border-radius: 10px;
  background: #f0f5ff;
}

.agent-page .agent-details-heading p {
  color: var(--agent-ink);
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.4px;
}

.agent-page .agent-section {
  flex-shrink: 0;
  min-width: 0;
  margin-bottom: 12px;
  padding: 16px;
  border: 1px solid var(--agent-line);
  border-radius: 11px;
  background: #fff;
}

.agent-page .agent-section-heading {
  align-items: center;
}

.agent-page .agent-section-heading p {
  color: var(--agent-ink);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}

.agent-page .agent-section-heading button {
  width: 28px;
  height: 28px;
  border-color: var(--agent-line);
  border-radius: 7px;
  background: #f8f9fc;
  color: #7a8ba5;
}

.agent-page .agent-inset {
  border-color: #e7edf6;
  border-radius: 9px;
  background: #f8faff;
  padding: 12px;
}

.agent-page .agent-details button {
  font-size: 12px;
  font-weight: 500;
}

.agent-page .agent-tool-option {
  align-items: flex-start;
  border-color: var(--agent-line);
  background: #f8f9fc;
  padding: 11px;
}

.agent-page .agent-tool-option > input {
  flex-shrink: 0;
  margin-top: 2px;
}

.agent-page .agent-tool-option > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.agent-page .agent-tool-option:has(input:checked) {
  border-color: #d6e3fd;
  background: #f1f6ff;
}

/* Leave the code editor's textarea/highlight geometry and syntax colors intact. */
.agent-page .custom-code-editor {
  border-color: #dce4f3;
  border-radius: 9px;
  box-shadow: none;
}

.agent-page .vibe-block-design-wizard-card {
  border-color: #e2eafb;
  border-radius: 12px;
  background: linear-gradient(135deg, #f6f9ff, #f9faff);
  box-shadow: none;
}

.agent-page .vibe-block-design-wizard-card--answered {
  border-color: #dcebe2;
  background: #f6fbf8;
}

.agent-page .vibe-block-design-wizard-card__question {
  color: var(--agent-ink);
  font-size: 16px;
  font-weight: 600;
}

:is(.agent-page, .agent-theme) .agent-overlay,
.agent-theme.agent-overlay {
  background: #202c4266;
  backdrop-filter: blur(3px);
}

.agent-page .agent-dialog,
.agent-create-session > form {
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  border: 1px solid #dfe7f3;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 18px 60px #20355426;
}

:is(.agent-page .agent-dialog, .agent-create-session) :is(h2, h3) {
  color: var(--agent-ink);
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.4px;
}

:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) :is(
  input:not([type='checkbox']):not([type='radio']):not([type='file']),
  select,
  textarea:not(.custom-code-editor__input)
) {
  min-width: 0;
  max-width: 100%;
  border: 1px solid #dce4f3;
  border-radius: 8px;
  background: #fff;
  color: #495870;
  font-size: 13px;
  box-shadow: none;
}

:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) :is(input, select, textarea):disabled {
  background: #f5f7fb;
  color: #93a0b4;
}

:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) button:disabled {
  box-shadow: none;
  opacity: 0.55;
}

.agent-session-menu {
  border-color: var(--agent-line);
  border-radius: 11px;
  box-shadow: 0 8px 28px #304a7614;
  font-size: 12px;
}

.agent-session-menu > div:first-child {
  padding: 12px 14px;
  background: #f8f9fc;
  border-color: var(--agent-line);
}

.agent-session-menu > div:first-child :is(span, button) {
  font-size: 12px;
}

.agent-session-menu li {
  min-height: 43px;
  padding: 11px 14px;
  color: #53617a;
}

.agent-session-menu li:hover {
  background: #f0f5ff;
}

.agent-create-session button {
  border-radius: 9px;
  font-weight: 500;
}

.agent-create-session button[aria-pressed] {
  border-width: 1px;
  border-radius: 12px;
  box-shadow: none;
}

.agent-page .loading-indicator-appear {
  border: 1px solid var(--agent-line);
  border-radius: 10px;
  box-shadow: 0 4px 14px #384c740d;
  color: #58667d;
}

.agent-page .mobile-brief-toggle {
  border: 1px solid #dbe7ff;
  border-radius: 15px;
  box-shadow: 0 4px 14px #165bfb20;
  filter: none;
}

.agent-page .agent-mobile-drawer {
  display: flex;
  flex-direction: column;
  height: 80vh;
  height: 80dvh;
  max-height: 80dvh;
  border: 1px solid var(--agent-line);
  border-radius: 18px 18px 0 0;
  background: #fff;
  box-shadow: 0 -8px 32px #2035541a;
}

.agent-page .agent-mobile-drawer > div:first-child {
  flex-shrink: 0;
}

.agent-page .agent-mobile-drawer .agent-details {
  flex: 1;
  min-height: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

@media (max-width: 1100px) {
  .agent-page .agent-messages {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 768px) {
  .agent-page .agent-header > div {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    padding: 12px 16px;
  }

  .agent-page .agent-header nav a {
    padding: 7px 8px;
    font-size: 11px;
  }

  .agent-page .agent-session-controls {
    flex: 1;
  }

  .agent-page .agent-session-controls > button:first-child {
    flex: 1;
    width: auto;
  }

  .agent-page .agent-header-sessions {
    flex: 1;
  }

  .agent-page .agent-header > div > div:first-child {
    grid-column: 1 / -1;
  }

  .agent-page .mobile-brief-toggle {
    bottom: 4px;
    width: 44px;
    height: 44px;
  }

  .agent-page .agent-messages {
    /* Override the legacy fixed clearance; the inline value tracks attachments/input height. */
    padding-bottom: var(--agent-message-clearance) !important;
  }

  .agent-page :is(.message-user-bubble, .message-ai-bubble, .message-error-bubble, .message-warning-bubble) {
    max-width: 100%;
    padding: 13px;
  }

  .agent-page .agent-composer-position.mobile-input-container {
    width: calc(100% - 32px) !important;
    padding: 0;
  }

  .agent-page .agent-mention-controls {
    position: relative;
  }

  .agent-page .agent-mention-controls > div {
    position: static;
  }

  .agent-page .agent-mention-menu {
    bottom: calc(100% + 8px);
    max-width: 100%;
  }

  .agent-page .agent-details-scroll {
    padding: 20px 18px 28px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .agent-page :is(.suggestion-button, .message-user-bubble, .message-ai-bubble, .assistant-icon-pulse) {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/agent-page.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,mFAAmF;EACnF,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;EAKE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2FAA2F;IAC3F,yDAAyD;EAC3D;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Agent-only presentation. Portal roots receive agent-theme explicitly. */\n.agent-page,\n.agent-theme {\n  --agent-blue: #165bfb;\n  --agent-ink: #202c42;\n  --agent-muted: #7a8496;\n  --agent-line: #e8ecf2;\n  --agent-canvas: #f8f9fc;\n  --agent-chat: #fcfdff;\n  color: var(--agent-ink);\n  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.agent-page,\n.agent-page .agent-layout {\n  height: 100vh;\n  height: 100dvh;\n  background: var(--agent-canvas);\n}\n\n:is(.agent-page, .agent-theme) :is(button, input, textarea, select) {\n  font-family: inherit;\n}\n\n:is(.agent-page, .agent-theme) :is(button, a, summary) {\n  -webkit-tap-highlight-color: transparent;\n}\n\n:is(.agent-page, .agent-theme) :focus-visible {\n  outline: 3px solid #8eb3ff;\n  outline-offset: 3px;\n}\n\n:is(.agent-page, .agent-theme) button:disabled {\n  cursor: not-allowed;\n}\n\n.agent-page .agent-header {\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--agent-line);\n}\n\n.agent-page .agent-header > div {\n  border-bottom: 0;\n}\n\n.agent-page .agent-header nav a {\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.agent-page .agent-header-sessions,\n.agent-page .agent-session-controls {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.agent-page .agent-session-controls {\n  gap: 8px;\n}\n\n.agent-page .agent-session-controls > button {\n  min-height: 40px;\n  border-radius: 9px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.agent-page .agent-session-controls > button:first-child {\n  min-width: 0;\n  border-color: var(--agent-line);\n  color: #495870;\n  background: #fff;\n  box-shadow: 0 1px 2px #304a7604;\n}\n\n.agent-page .agent-session-controls > button:first-child:hover {\n  border-color: #c4d6f6;\n  background: #f8faff;\n}\n\n.agent-page .agent-session-controls > button + button {\n  flex-shrink: 0;\n  background: var(--agent-blue);\n  box-shadow: 0 3px 5px #165bfb12;\n}\n\n.agent-page .agent-session-controls > button + button:hover:not(:disabled) {\n  background: #084ee9;\n}\n\n.agent-page .agent-header button[aria-label='Logout'] {\n  min-height: 40px;\n  padding: 8px 15px;\n  border: 1px solid #f0dce0;\n  border-radius: 9px;\n  background: #fff5f6;\n  color: #b4232f;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.agent-page .agent-header button[aria-label='Logout']:hover {\n  background: #ffebee;\n}\n\n.agent-page :is(.agent-content, .agent-conversation, .agent-chat) {\n  min-width: 0;\n  min-height: 0;\n}\n\n.agent-page .agent-conversation {\n  background: var(--agent-chat);\n}\n\n.agent-page .agent-sidebar-column {\n  flex: 0 0 380px;\n}\n\n.agent-page .agent-messages {\n  overscroll-behavior: contain;\n  padding-top: 28px;\n}\n\n.agent-page .agent-message {\n  margin-bottom: 26px;\n}\n\n.agent-page :is(.agent-message-row, .agent-message-body) {\n  min-width: 0;\n}\n\n.agent-page :is(.message-user-bubble, .message-ai-bubble, .message-error-bubble, .message-warning-bubble) {\n  min-width: 0;\n  padding: 16px 18px;\n  border: 1px solid var(--agent-line);\n  box-shadow: none;\n}\n\n.agent-page .message-user-bubble {\n  border-color: #e4ecfc;\n  border-radius: 12px 12px 3px 12px;\n  background: #edf3ff;\n  color: #496088;\n}\n\n.agent-page .message-ai-bubble {\n  border-radius: 3px 12px 12px 12px;\n  background: #fff;\n  color: #58667d;\n}\n\n.agent-page :is(.chat-rich-text, .chat-rich-text p) {\n  color: inherit;\n  font-size: 14px;\n  line-height: 1.85;\n  overflow-wrap: anywhere;\n}\n\n.agent-page .chat-rich-text a {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.agent-page :is(.message-error-bubble, .message-warning-bubble) {\n  border-radius: 3px 12px 12px 12px;\n}\n\n.agent-page .message-error-bubble {\n  border-color: #f3d0d3;\n  background: #fff5f6;\n}\n\n.agent-page .message-warning-bubble {\n  border-color: #f1dfb5;\n  background: #fffbf0;\n}\n\n.agent-page :is(.message-error-bubble, .message-warning-bubble) p {\n  font-size: 14px;\n  line-height: 1.8;\n}\n\n.agent-page .agent-avatar {\n  flex-shrink: 0;\n  width: 34px;\n  height: 35px;\n  border: 1px solid #e0e9ff;\n  border-radius: 11px;\n  background: linear-gradient(135deg, #f0f5ff, #f7f5ff);\n}\n\n.agent-page .agent-avatar > div {\n  border-radius: inherit;\n  background: transparent;\n}\n\n.agent-page .agent-user-avatar {\n  flex-shrink: 0;\n  width: 34px;\n  height: 35px;\n  border: 1px solid #e2e8f2;\n  border-radius: 11px;\n  background: #edf1f7;\n}\n\n.agent-page .agent-user-avatar p {\n  color: #64738a;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.agent-page :is(.agent-user-text, .agent-user-text p) {\n  color: #496088;\n  font-size: 14px;\n  line-height: 1.85;\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.agent-page .agent-message-actions {\n  gap: 6px;\n  margin-top: 14px;\n  padding-top: 10px;\n  border-top: 1px solid #e8edf5;\n}\n\n.agent-page .agent-message-action {\n  min-height: 28px;\n  border-radius: 7px;\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.agent-page .agent-message-meta {\n  border-radius: 6px;\n  padding: 4px 7px;\n  color: var(--agent-muted);\n  background: #f5f7fb;\n  font-size: 10px;\n}\n\n.agent-page :is(.agent-context-card, .agent-router) {\n  border-radius: 10px;\n  border-width: 1px;\n  padding: 12px;\n}\n\n.agent-page .agent-context-card {\n  border-color: #e2eafb;\n  background: #f7faff;\n}\n\n.agent-page .agent-composer-position button:not(.agent-attach-button) {\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.agent-page .agent-mention-menu {\n  max-width: calc(100vw - 48px);\n  border-color: var(--agent-line);\n  border-radius: 11px;\n  box-shadow: 0 8px 28px #304a7614;\n}\n\n.agent-page :is(.agent-context-card, .agent-router) button {\n  border-radius: 7px;\n  font-weight: 500;\n}\n\n.agent-page .agent-composer-fade {\n  background: linear-gradient(to top, var(--agent-chat) 45%, #fcfdff00);\n}\n\n.agent-page .agent-composer-position {\n  width: calc(100% - 48px);\n}\n\n.agent-page .agent-composer-position::before {\n  position: absolute;\n  z-index: -1;\n  inset: -20px -16px -52px;\n  background: linear-gradient(to top, var(--agent-chat) calc(100% - 20px), #fcfdff00);\n  content: '';\n  pointer-events: none;\n}\n\n.agent-page .agent-composer {\n  min-width: 0;\n  border: 1px solid #dce4f3;\n  border-radius: 12px;\n  box-shadow: 0 4px 14px #384c7404;\n  transition: border-color 0.15s;\n}\n\n.agent-page .agent-composer:focus-within {\n  border-color: #98b8fa;\n  outline: 3px solid #165bfb08;\n}\n\n.agent-page .agent-upgrade-button {\n  border-radius: 8px;\n  background: var(--agent-blue);\n}\n\n.agent-page .agent-upgrade-button:disabled {\n  opacity: 0.6;\n}\n\n.agent-page .agent-composer-outline {\n  display: none;\n}\n\n.agent-page :is(.agent-composer-input, .agent-composer-placeholder, .agent-composer-placeholder p) {\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.agent-page .agent-composer-input {\n  color: var(--agent-ink);\n  outline: none;\n}\n\n.agent-page .agent-composer-placeholder {\n  color: #909db0;\n  pointer-events: none;\n}\n\n.agent-page .agent-attach-button {\n  border: 1px solid #e2eafb;\n  border-radius: 9px;\n  color: var(--agent-blue);\n  background: #edf3ff;\n}\n\n.agent-page .agent-attach-button:hover:not(:disabled) {\n  background: #e0eaff;\n}\n\n.agent-page .agent-attach-button path {\n  fill: currentColor;\n}\n\n.agent-page .agent-send-button {\n  flex-shrink: 0;\n  border: 1px solid var(--agent-line);\n  border-radius: 12px;\n  background: #f1f4f9;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.agent-page .agent-send-button.agent-send-ready:not([aria-disabled='true']) {\n  border-color: var(--agent-blue);\n  background: var(--agent-blue);\n  box-shadow: 0 3px 5px #165bfb12;\n}\n\n.agent-page .agent-send-ready:not([aria-disabled='true']) path {\n  fill: #fff;\n}\n\n.agent-page .agent-send-ready:not([aria-disabled='true']):hover {\n  background: #084ee9;\n}\n\n.agent-page .suggestion-button {\n  max-width: 100%;\n  border: 1px solid #dce6f6;\n  border-radius: 9px;\n  background: #fff;\n  color: #536c96;\n  box-shadow: 0 1px 2px #304a7604;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.agent-page .suggestion-button:hover {\n  border-color: #adc7ff;\n  background: #f7faff;\n}\n\n.agent-page .suggestion-button p {\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.agent-page .agent-suggestion-outline {\n  display: none;\n}\n\n.agent-page :is(.completion-button-primary, .completion-button-secondary) {\n  border-radius: 9px;\n  box-shadow: none;\n  font-size: 12px;\n}\n\n.agent-page .agent-details {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border-left: 1px solid var(--agent-line);\n  border-radius: 0;\n  background: #fff;\n}\n\n.agent-page .agent-details-divider {\n  display: none;\n}\n\n.agent-page .agent-details-scroll {\n  flex: 1;\n  min-height: 0;\n  height: auto;\n  padding: 25px 22px 32px;\n  overscroll-behavior: contain;\n}\n\n.agent-page .agent-details-heading {\n  margin-bottom: 24px;\n}\n\n.agent-page .agent-details-heading svg {\n  width: 22px;\n  height: 22px;\n}\n\n.agent-page .agent-details-heading > div > div:first-child {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 35px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f0f5ff;\n}\n\n.agent-page .agent-details-heading p {\n  color: var(--agent-ink);\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: -0.4px;\n}\n\n.agent-page .agent-section {\n  flex-shrink: 0;\n  min-width: 0;\n  margin-bottom: 12px;\n  padding: 16px;\n  border: 1px solid var(--agent-line);\n  border-radius: 11px;\n  background: #fff;\n}\n\n.agent-page .agent-section-heading {\n  align-items: center;\n}\n\n.agent-page .agent-section-heading p {\n  color: var(--agent-ink);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.agent-page .agent-section-heading button {\n  width: 28px;\n  height: 28px;\n  border-color: var(--agent-line);\n  border-radius: 7px;\n  background: #f8f9fc;\n  color: #7a8ba5;\n}\n\n.agent-page .agent-inset {\n  border-color: #e7edf6;\n  border-radius: 9px;\n  background: #f8faff;\n  padding: 12px;\n}\n\n.agent-page .agent-details button {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.agent-page .agent-tool-option {\n  align-items: flex-start;\n  border-color: var(--agent-line);\n  background: #f8f9fc;\n  padding: 11px;\n}\n\n.agent-page .agent-tool-option > input {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.agent-page .agent-tool-option > div {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.agent-page .agent-tool-option:has(input:checked) {\n  border-color: #d6e3fd;\n  background: #f1f6ff;\n}\n\n/* Leave the code editor's textarea/highlight geometry and syntax colors intact. */\n.agent-page .custom-code-editor {\n  border-color: #dce4f3;\n  border-radius: 9px;\n  box-shadow: none;\n}\n\n.agent-page .vibe-block-design-wizard-card {\n  border-color: #e2eafb;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f6f9ff, #f9faff);\n  box-shadow: none;\n}\n\n.agent-page .vibe-block-design-wizard-card--answered {\n  border-color: #dcebe2;\n  background: #f6fbf8;\n}\n\n.agent-page .vibe-block-design-wizard-card__question {\n  color: var(--agent-ink);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n:is(.agent-page, .agent-theme) .agent-overlay,\n.agent-theme.agent-overlay {\n  background: #202c4266;\n  backdrop-filter: blur(3px);\n}\n\n.agent-page .agent-dialog,\n.agent-create-session > form {\n  max-height: calc(100dvh - 32px);\n  overflow-y: auto;\n  border: 1px solid #dfe7f3;\n  border-radius: 15px;\n  background: #fff;\n  box-shadow: 0 18px 60px #20355426;\n}\n\n:is(.agent-page .agent-dialog, .agent-create-session) :is(h2, h3) {\n  color: var(--agent-ink);\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.4px;\n}\n\n:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) :is(\n  input:not([type='checkbox']):not([type='radio']):not([type='file']),\n  select,\n  textarea:not(.custom-code-editor__input)\n) {\n  min-width: 0;\n  max-width: 100%;\n  border: 1px solid #dce4f3;\n  border-radius: 8px;\n  background: #fff;\n  color: #495870;\n  font-size: 13px;\n  box-shadow: none;\n}\n\n:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) :is(input, select, textarea):disabled {\n  background: #f5f7fb;\n  color: #93a0b4;\n}\n\n:is(.agent-page .agent-details, .agent-page .agent-dialog, .agent-create-session) button:disabled {\n  box-shadow: none;\n  opacity: 0.55;\n}\n\n.agent-session-menu {\n  border-color: var(--agent-line);\n  border-radius: 11px;\n  box-shadow: 0 8px 28px #304a7614;\n  font-size: 12px;\n}\n\n.agent-session-menu > div:first-child {\n  padding: 12px 14px;\n  background: #f8f9fc;\n  border-color: var(--agent-line);\n}\n\n.agent-session-menu > div:first-child :is(span, button) {\n  font-size: 12px;\n}\n\n.agent-session-menu li {\n  min-height: 43px;\n  padding: 11px 14px;\n  color: #53617a;\n}\n\n.agent-session-menu li:hover {\n  background: #f0f5ff;\n}\n\n.agent-create-session button {\n  border-radius: 9px;\n  font-weight: 500;\n}\n\n.agent-create-session button[aria-pressed] {\n  border-width: 1px;\n  border-radius: 12px;\n  box-shadow: none;\n}\n\n.agent-page .loading-indicator-appear {\n  border: 1px solid var(--agent-line);\n  border-radius: 10px;\n  box-shadow: 0 4px 14px #384c740d;\n  color: #58667d;\n}\n\n.agent-page .mobile-brief-toggle {\n  border: 1px solid #dbe7ff;\n  border-radius: 15px;\n  box-shadow: 0 4px 14px #165bfb20;\n  filter: none;\n}\n\n.agent-page .agent-mobile-drawer {\n  display: flex;\n  flex-direction: column;\n  height: 80vh;\n  height: 80dvh;\n  max-height: 80dvh;\n  border: 1px solid var(--agent-line);\n  border-radius: 18px 18px 0 0;\n  background: #fff;\n  box-shadow: 0 -8px 32px #2035541a;\n}\n\n.agent-page .agent-mobile-drawer > div:first-child {\n  flex-shrink: 0;\n}\n\n.agent-page .agent-mobile-drawer .agent-details {\n  flex: 1;\n  min-height: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n@media (max-width: 1100px) {\n  .agent-page .agent-messages {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .agent-page .agent-header > div {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 10px;\n    padding: 12px 16px;\n  }\n\n  .agent-page .agent-header nav a {\n    padding: 7px 8px;\n    font-size: 11px;\n  }\n\n  .agent-page .agent-session-controls {\n    flex: 1;\n  }\n\n  .agent-page .agent-session-controls > button:first-child {\n    flex: 1;\n    width: auto;\n  }\n\n  .agent-page .agent-header-sessions {\n    flex: 1;\n  }\n\n  .agent-page .agent-header > div > div:first-child {\n    grid-column: 1 / -1;\n  }\n\n  .agent-page .mobile-brief-toggle {\n    bottom: 4px;\n    width: 44px;\n    height: 44px;\n  }\n\n  .agent-page .agent-messages {\n    /* Override the legacy fixed clearance; the inline value tracks attachments/input height. */\n    padding-bottom: var(--agent-message-clearance) !important;\n  }\n\n  .agent-page :is(.message-user-bubble, .message-ai-bubble, .message-error-bubble, .message-warning-bubble) {\n    max-width: 100%;\n    padding: 13px;\n  }\n\n  .agent-page .agent-composer-position.mobile-input-container {\n    width: calc(100% - 32px) !important;\n    padding: 0;\n  }\n\n  .agent-page .agent-mention-controls {\n    position: relative;\n  }\n\n  .agent-page .agent-mention-controls > div {\n    position: static;\n  }\n\n  .agent-page .agent-mention-menu {\n    bottom: calc(100% + 8px);\n    max-width: 100%;\n  }\n\n  .agent-page .agent-details-scroll {\n    padding: 20px 18px 28px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .agent-page :is(.suggestion-button, .message-user-bubble, .message-ai-bubble, .assistant-icon-pulse) {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
